import "@/App.css";
import { Component } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import VillaDetail from "@/pages/VillaDetail";
import PromoDetail from "@/pages/PromoDetail";
import BookingPage from "@/pages/BookingPage";
import BlogDetail from "@/pages/BlogDetail";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminPanel from "@/pages/admin/AdminPanel";

class RouteErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Route render error", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div data-testid="app-error-boundary" className="min-h-screen bg-[#FBF9F5] flex items-center justify-center px-5">
        <div className="max-w-md text-center">
          <p className="text-[11px] uppercase tracking-[0.24em] font-sans font-semibold text-[#9A7B66]">Nusadira Lembongan</p>
          <h1 className="mt-4 font-serif text-3xl text-[#2C2825]">This page needs a moment.</h1>
          <p className="mt-3 text-sm text-[#6E675F] font-sans leading-relaxed">
            Please refresh once. If it continues, our team can restore the page from the admin console.
          </p>
          <button
            data-testid="app-error-reload"
            onClick={() => window.location.reload()}
            className="mt-6 px-6 py-3 rounded-sm bg-[#9A7B66] text-white text-[11px] font-sans font-semibold uppercase tracking-[0.16em]"
          >
            Refresh Page
          </button>
        </div>
      </div>
    );
  }
}


function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <RouteErrorBoundary>
          <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/villa/:id" element={<VillaDetail />} />
        <Route path="/offer/:id" element={<PromoDetail />} />
        <Route path="/book" element={<BookingPage />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
        <Route path="/console/login" element={<AdminLogin />} />
        <Route path="/console" element={<AdminPanel />} />
        <Route path="/admin" element={<Navigate to="/console" replace />} />
        <Route path="/admin/login" element={<Navigate to="/console/login" replace />} />
          </Routes>
        </RouteErrorBoundary>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
